import { cloneDeep } from "lodash";
import { UPDATE_FORCES_INPUT_ERROR, UPDATE_FORCES_INPUT_STARTING, UPDATE_FORCES_INPUT_SUCCESS } from "../../../constants/actionTypes";
import initialState from "../../../store/initialState";

export default function updateForcesInputReducer(state = initialState.updateForcesInput, action) {

    switch (action.type) {
        case UPDATE_FORCES_INPUT_STARTING: {
            const { memberId } = action;
            const newState = cloneDeep(state);
            if (!newState[memberId]) {
                newState[memberId] = cloneDeep(initialState.updateForcesInput.forcesInputId);
            }
            const forcesInputData = newState[memberId];
            forcesInputData.saving = true;
            forcesInputData.saved = false;
            forcesInputData.error = null;

            return newState;
        }
        case UPDATE_FORCES_INPUT_SUCCESS: {
            const { memberId } = action;
            const newState = cloneDeep(state);
            if (!newState[memberId]) {
                newState[memberId] = cloneDeep(initialState.updateForcesInput.forcesInputId);
            }

            const forcesInputData = newState[memberId];
            forcesInputData.saving = false;
            forcesInputData.saved = true;
            forcesInputData.error = null;
            return newState;
        }

        case UPDATE_FORCES_INPUT_ERROR: {
            const { memberId } = action;
            const newState = cloneDeep(state);

            if (!newState[memberId]) {
                newState[memberId] = cloneDeep(initialState.updateForcesInput.forcesInputId);
            }

            const forcesInputData = newState[memberId];
            forcesInputData.saving = false;
            forcesInputData.saved = false;
            forcesInputData.error = action.err;
            return newState;
        }
        default: {
            return state;
        }
    }
}